document.addEventListener('change', (event) => { if(event.target.matches('[data-variant-selector]')) { const url=new URL(location.href); url.searchParams.set('variant',event.target.value); location.assign(url.href); } });
document.addEventListener('keydown',(event)=>{if(event.key==='Escape'){const menu=document.querySelector('details.menu[open]');if(menu){menu.open=false;menu.querySelector('summary').focus();}}});
document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product-media');
  const dialog = document.querySelector('[data-artwork-lightbox]');
  if (!gallery || !dialog || typeof dialog.showModal !== 'function') return;

  const links = [...gallery.querySelectorAll('[data-artwork-image]')];
  if (!links.length) return;
  const image = dialog.querySelector('[data-lightbox-image]');
  const counter = dialog.querySelector('[data-lightbox-counter]');
  const previous = dialog.querySelector('[data-lightbox-prev]');
  const next = dialog.querySelector('[data-lightbox-next]');
  let index = 0;
  let touchStart = null;

  const show = (newIndex) => {
    index = (newIndex + links.length) % links.length;
    image.src = links[index].href;
    image.alt = links[index].querySelector('img')?.alt || '';
    counter.textContent = `${index + 1} / ${links.length}`;
  };

  previous.hidden = next.hidden = links.length < 2;
  gallery.addEventListener('click', (event) => {
    const link = event.target.closest('[data-artwork-image]');
    if (!link || !gallery.contains(link)) return;
    event.preventDefault();
    show(links.indexOf(link));
    dialog.showModal();
  });
  previous.addEventListener('click', () => show(index - 1));
  next.addEventListener('click', () => show(index + 1));
  dialog.querySelector('[data-lightbox-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => { image.removeAttribute('src'); });
  dialog.addEventListener('keydown', (event) => {
    if (links.length < 2) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(index + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  dialog.addEventListener('touchstart', (event) => {
    if (event.touches.length === 1) touchStart = { x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true });
  dialog.addEventListener('touchend', (event) => {
    if (!touchStart || links.length < 2 || event.changedTouches.length !== 1) return;
    const dx = event.changedTouches[0].clientX - touchStart.x;
    const dy = event.changedTouches[0].clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) show(index + (dx < 0 ? 1 : -1));
  }, { passive: true });
});
